import { z } from 'zod';

export const SubsidyType = z.enum([
  'MedicaidEligible',
  'NoMedicaidEligible',
  'SubsidyEligible',
  'NoSubsidyEligible',
]);

export type SubsidyType = z.infer<typeof SubsidyType>;
